class HeroSlider extends HTMLElement {
  constructor() {
    super();

    this.delay = this.querySelector('[data-delay]').getAttribute('data-delay');

    const swiper = new Swiper(this.querySelector(".hero-swipper"), {
      // Optional parameters
      direction: "horizontal",
      loop: true,
      speed: 1000,
      autoplay: {
        delay: this.delay,
      },
      // If we need pagination
      pagination: {
        el: this.querySelector(".swiper-pagination"),
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },

      // And if we need scrollbar
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
      },
    });
  }
}

customElements.define("hero-slider", HeroSlider);
